import { Dispatch, SetStateAction, useEffect } from 'react';
import { Session } from 'next-auth';
import { useTranslation } from 'next-i18next';
import { observer } from 'mobx-react-lite';
import CreativeModalLogin from '@components/CreativeModalContent/CreativeModalLogin';
import CreativeModalAddProject from '@components/CreativeModalContent/CreativeModalAddProject';
import CreativeModalSummary from '@components/CreativeModalContent/CreativeModalSummary';
import Loader from '@components/Loader/Loader';
import { useCustomerDataStore } from '@features/customerData/mobx/context/CustomerDataStoreProvider';
import isValidCommerceCustomerId from '@features/customerData/utils/isValidCommerceCustomerId';
import Modal from '@components/Modal/Modal';
import styles from '@components/CreativeModalContent/CreativeModalContent.style';
import { TCreativeModalType } from '@components/CreativeModalContent/types';
import CreativeModalShareProject from '@components/CreativeModalContent/CreativeModalShareProject/CreativeModalShareProject';
type PropsType = {
  isUserLogged: Session | null;
  isProjectCreated: boolean;
  setProjectCreated: Dispatch<SetStateAction<boolean>>;
  uuId: string;
  imageUrl: string;
  setValueModal: Dispatch<SetStateAction<boolean>>;
  active: boolean;
  modalType: TCreativeModalType;
};
const CreativeModalContent = ({
  isUserLogged,
  isProjectCreated,
  setProjectCreated,
  uuId,
  imageUrl,
  active,
  setValueModal,
  modalType
}: PropsType) => {
  const customerDataStore = useCustomerDataStore();
  const {
    t
  } = useTranslation('common');
  useEffect(() => {
    if (!active || !isUserLogged || modalType !== 'saveProject' || isValidCommerceCustomerId(customerDataStore.id)) {
      return;
    }
    const loadCustomerId = async () => {
      const fromSession = await customerDataStore.getCustomerFromSession();
      if (!fromSession || !isValidCommerceCustomerId(customerDataStore.id)) {
        await customerDataStore.fetchAndPopulateCustomerDataStore();
      }
    };
    void loadCustomerId();
  }, [active, isUserLogged, modalType, customerDataStore.id, customerDataStore]);
  const isCustomerIdLoading = isUserLogged && modalType === 'saveProject' && !isProjectCreated && (customerDataStore.isFetchingInProgress || !isValidCommerceCustomerId(customerDataStore.id));
  if (modalType === 'shareProject') {
    return <Modal closeFunc={setValueModal} active={active} heading={t('creative.modal.heading')}>
        <CreativeModalShareProject uuId={uuId} />
      </Modal>;
  }
  if (isUserLogged && modalType === 'saveProject') {
    return <Modal closeFunc={setValueModal} active={active} heading={t('creative.modal.heading')}>
        {isProjectCreated ? <CreativeModalSummary setValueModal={setValueModal} /> : isCustomerIdLoading ? <Loader /> : <CreativeModalAddProject uuId={uuId} imageUrl={imageUrl} setProjectCreated={setProjectCreated} setValueModal={setValueModal} />}
      </Modal>;
  }
  return <Modal variant="login" fullScreen={true} borderLess={true} closeFunc={setValueModal} active={active} closeOnOutsideClick addSx={styles.modal} heading={t('creative.modal.heading')}>
      <CreativeModalLogin uuId={uuId} imageUrl={imageUrl} />
    </Modal>;
};
export default observer(CreativeModalContent);